import { SelectOption } from "@interfaces/misc"
import Select from "react-select"

interface SelectInputProps {
  label: string
  placeholder: string
  options: SelectOption[]
  onChange: (opt: SelectOption | null) => void
  errorMessage?: string
}

export function SelectInput({
  label,
  placeholder,
  options,
  onChange,
  errorMessage,
}: SelectInputProps) {
  return (
    <div className="w-full">
      <label className="text-gray-8e sm:text-sm text-xxs">{label} </label>
      <Select
        placeholder={placeholder}
        options={options}
        onChange={(v) => onChange(v)}
        styles={{
          control: (props) => ({
            display: "flex",
            padding: "8px",
            borderColor: errorMessage ? "#ef2547" : "#ececec",
            boxShadow: "0 0 0 #ececec",
            borderBottom: errorMessage ? "1px solid #ef2547" : "1px solid #8E8E8E",
            minHeight: 0,
            fontSize: "14px",
            "@media(max-width: 576px)": {
              fontSize: "12px",
              padding: "8px 0",
            },
          }),
          input: (props) => ({
            ...props,
            margin: 0,
            paddingTop: 0,
            paddingBottom: 0,
          }),
          placeholder: (props) => ({
            ...props,
            color: "#979797",
            marginLeft: 0,
            marginRight: 0,
            fontSize: "12px",
          }),
          dropdownIndicator: (props) => ({
            ...props,
            padding: 0,
          }),
          valueContainer: (props) => ({
            ...props,
            padding: "0 5px 0 0",
          }),
          indicatorSeparator: (props) => ({
            display: "none",
          }),
          option: (props, { isSelected }) => ({
            ...props,
            fontSize: "14px",
            backgroundColor: isSelected ? "#0DAD8E" : "white",
            "&:active": {
              backgroundColor: "rgba(13, 173, 142, 0.5)",
            },
            "@media(max-width: 576px)": {
              fontSize: "12px",
            },
          }),
        }}
      />
      <small className="text-red">{errorMessage}</small>
    </div>
  )
}
